import qs from 'qs';
import { useLocation } from 'react-router-dom';

export function useQueryParams<T>() {
	const location = useLocation();

	return (qs.parse(location.search.replace('?', '')) as unknown) as T;
}
